export var TOKEN_KEY = 'token';
export var USER_DATA_KEY = 'views';
export var EMAIL_FORMAT = 'emailFormat';
export var LANGUAGE_KEY = 'language';
export var WD_SUMARY_CACHE_KEY = 'wd_sumary_key';
export var WD_TOP3_INCREASE_CACHE_KEY = 'wd_top3_rate_increase_key';
export var WD_TOP3_DECREASE_CACHE_KEY = 'wd_top3_rate_decrease_key';
